import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { Auth, API, graphqlOperation } from "aws-amplify";
import { getidCard } from "../../graphql/myQueries";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import Alert from "@mui/material/Alert";
import Skeleton from "@mui/material/Skeleton";
import UseOpenpay from "../../User/UI/formcard/hooks/openpay";
import SavingsIcon from "@mui/icons-material/Savings";

const useStyles = makeStyles((theme) => ({
  profileContainer: {
    marginTop: "5vh",
    minHeight: "90vh",
    background: "#ffffff",
    padding: "30px 15px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",

    width: "50%",
    marginLeft: "25%",
    backgroundColor: "#ffffff",
    borderRadius: "15px",
  },
  infoContainer: {
    marginTop: "30%",
    paddingLeft: 10,
    width: "90%",

    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    alignItems: "center",
  },
  info: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "start",
    flexDirection: "column",
    gap: 2,
  },
  name: {
    fontSize: 18,
    lineHeight: "22px",
    color: "#fff",
    fontWeight: 500,
    position: "absolute",
    marginLeft: "-80%",
    marginTop: "-2%",
    textDecoration: "none",
  },
  nameCLABE: {
    fontSize: 18,
    lineHeight: "22px",
    color: "#fff",
    fontWeight: 500,
    position: "absolute",
    marginLeft: "-60%",
    marginTop: "-2%",
    textDecoration: "none",
  },
  butonscontainer: {
    width: "50%",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  infoCard: {
    fontSize: 18,
    lineHeight: "22px",
    color: "#000000",
    fontWeight: 500,
    position: "absolute",
    marginLeft: "-80%",
    marginTop: "-2%",
    textDecoration: "none",
    justifyContent: "center",
    alignItems: "center",
  },
  cntCardInfo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginLeft: "-25px",
    backgroundColor: "#000000",
  },
  headerCard: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-6px",

    marginBottom: "18px",
  },
  skeletoncnt: {
    marginLeft: "10%",
    marginTop: "-10%",
  },
}));

function isObjEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }
  return true;
}
var kkys = require("./formcard/hooks/envscomercial");

export default function Choose() {
/*   console.log(kkys.apikeyPrivadaOpp); */
  const { getCLABE, getCARD } = UseOpenpay();
  const classes = useStyles();
  const [_idopp, _setidopp] = useState({});
  const [alert, setAlert] = useState(false);
  const [skeleton, setSkeleton] = useState(true);
  const [resCLABE, setresClabe] = useState({});
  const [resCard, setresCard] = useState({});

  useEffect(() => {
    async function getUserLoggedIn() {
      try {
        const response = await Auth.currentAuthenticatedUser();
        const responseOpenpay = await API.graphql(
          graphqlOperation(getidCard, { id: response.attributes.sub })
        );
        var idopenpay = responseOpenpay.data.getAccount.openPay_id;

        _setidopp(JSON.parse(idopenpay != null ? idopenpay : "{}"));
      } catch (err) {
        console.log("Hubo un error al recuperar al usuario", err);
      }
    }
    getUserLoggedIn();
  }, []);
  useEffect(() => {
    if (!isObjEmpty(_idopp)) {
      getCLABEFN();
      getCARDFN();
      setTimeout(() => {
        setSkeleton(false);
      }, 3000);
      console.log("idopp", _idopp);

    } else {
      setTimeout(() => {
        setSkeleton(false);
      }, 3000);
      console.log("No hay idopp");
     // window.location.reload();
    }
  }, [_idopp]);
  function startAlert() {
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 3000);
  }
  function getCLABEFN() {
    getCLABE(_idopp.openPay_id, _idopp.idclabe, function (err, res) {
      if (err) {
        console.log("error", err);
      } else {
        console.log("res", res);
        setresClabe(res);
      }
    });
  }
  function getCARDFN() {
    getCARD(_idopp.openPay_id, _idopp.idcard, function (err, res) {
      if (err) {
        console.log("error", err);
      } else {
        setresCard(res);
      }
    });
  }

  return (
    <div className={classes.profileContainer}>
      <div className={classes.infoContainer}>
        {skeleton ? (
          <div className={classes.skeletoncnt}>
            <Skeleton
              sx={{ borderRadius: "25px" }}
              animation="wave"
              /*  variant="rectangular" */ width={200}
              height={290}
            />
          </div>
        ) : (
          <div className={classes.butonscontainer}>
            {isObjEmpty(resCard) ? (
              <Button>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    "& > :not(style)": {
                      m: 1,
                      width: 180,
                      height: 180,
                      backgroundColor: "#EA5B13",
                      borderRadius: "10%",
                    },
                  }}
                >
                  <Paper elevation={3} />
                </Box>
                <div>
                  <div className={classes.info}>
                    <Link to="/registrotarjeta" className={classes.name}>
                      <p>Ingresar tarjeta</p>
                    </Link>
                  </div>
                </div>
                -
              </Button>
            ) : (
              <Button
                onClick={() => {
                  startAlert();
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    "& > :not(style)": {
                      m: 1,
                      width: 180,
                      height: 180,
                      backgroundColor: "#fff",
                      borderRadius: "10%",
                    },
                  }}
                >
                  <Paper elevation={5} />
                </Box>
                <div>
                  <div className={classes.cntCardInfo}>
                    <h1 className={classes.infoCard}>
                      <div className={classes.headerCard}>
                        <p>Tarjeta</p>
                      </div>
                      <CreditScoreIcon
                        sx={{ color: "#EA5B13", fontSize: "1.875rem" }}
                      />
                      <p>{resCard?.card_number?.substring(0, 4)}***</p>
                      <p>{resCard?.brand?.toUpperCase()} </p>
                      {/*         <p>{resCard.holder_name} </p> */}
                    </h1>
                  </div>
                </div>
              </Button>
            )}
          </div>
        )}

        {skeleton ? (
          <div className={classes.skeletoncnt}>
            <Skeleton
              sx={{ borderRadius: "25px" }}
              animation="wave"
              /* variant="rectangular" */ width={200}
              height={290}
            />
          </div>
        ) : (
          <div className={classes.butonscontainer}>
            {isObjEmpty(resCLABE) ? (
              <Button>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    "& > :not(style)": {
                      m: 1,
                      width: 180,
                      height: 180,
                      backgroundColor: "#EA5B13",
                      borderRadius: "10%",
                    },
                  }}
                >
                  <Paper elevation={3} />
                </Box>
                <div>
                  <div className={classes.info}>
                    <Link to="/registroCLABE" className={classes.nameCLABE}>
                      CLABE
                    </Link>
                  </div>
                </div>
              </Button>
            ) : (
              <Button
                onClick={() => {
                  startAlert();
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    "& > :not(style)": {
                      m: 1,
                      width: 180,
                      height: 180,
                      backgroundColor: "#fff",
                      borderRadius: "10%",
                    },
                  }}
                >
                  <Paper elevation={5} />
                </Box>
                <div>
                  <div className={classes.cntCardInfo}>
                    <h1 className={classes.infoCard}>
                      <div className={classes.headerCard}>
                        <p>CLABE</p>
                      </div>
                      <SavingsIcon
                        sx={{ color: "#EA5B13", fontSize: "1.875rem" }}
                      />
                      <p>
                        {resCLABE?.clabe?.substring(0, 4) != undefined
                          ? resCLABE?.clabe?.substring(0, 4)
                          : ""}
                        ***
                      </p>
                      <p>
                        {resCLABE?.holder_name != undefined
                          ? resCLABE?.holder_name
                          : ""}{" "}
                      </p>
                    </h1>
                  </div>
                </div>
              </Button>
            )}
          </div>
        )}
      </div>
      <br></br>
      {alert ? (
        <Alert severity="warning">
          Si deseas cambiar tu informacion bancaria — comunicate con Niku!
        </Alert>
      ) : null}
    </div>
  );
}
